<template>
<div class="container" style="margin: 10px auto 80px auto">	    
    <div class="row border-bottom pb-2">  
        <div class="col">
            <h3 class="display-5"><i class="text-danger fas" :class="{'fa-file-invoice-dollar': !loading && !letterLoading && !downloading, 'fa-circle-notch fa-spin': loading || letterLoading || downloading}"></i> Documents by Receipt Number</h3>
        </div>
    </div>
    <div class="row mt-2">
        <h4>Enter one or more receipt numbers</h4>        
    </div>
    <div>
        <div class="form-row">
            <div class="col input-group form-label-group" :class="{'has-items': receipts.length > 0}">
                <input type="text" maxlength="10" v-on:keyup.enter="addReceipt()" v-model="receipt" placeholder="Enter a receipt number" class="form-control">
                <label>Enter a receipt number</label>                 
                <button type="button" :disabled="receipt.trim() == ''" v-on:click="addReceipt()" class="btn btn-success"><i class="fas fa-plus"></i> Add</button>
                <button type="button" :disabled="receipt.trim() == ''" v-on:click="receipt = '';" class="btn btn-danger"><i class="fas fa-times"></i> Clear</button>                
            </div>               
        </div>
        <div class="card mb-3" v-if="receipts.length">
            <ul class="list-group list-group-flush">
                <li :key="i" class="list-group-item" v-for="(r, i) in receipts">
                    <div class="float-start">
                        <div>{{r.RECEIPT_NUMBER}}
                            <span v-if="r.ADV_RECEIPT_NUMBER" class="badge bg-primary me-2"><i aria-hidden="true" class="fa fa-history"></i> <strong>Historical receipt</strong> {{r.ADV_RECEIPT_NUMBER}}</span> 
                            <span v-if="r.REVERSAL == 'Y'" class="badge bg-warning"><i aria-hidden="true" class="fa fa-bell"></i> Modification</span>
                        </div>
                        <div class="detail">
                            <div><strong>Donor: </strong>{{r.LABEL_NAME_LINE1}} ({{r.ID_NUMBER1}})</div>                            
                            <div><strong>Processed:</strong> {{r.PROCESSED_DATE}} <strong>Date of record:</strong> {{r.DATE_OF_RECORD}}</div>
                            <div><strong>e-Receipt status:</strong> {{ereceiptStatus(r)}}</div>
                        </div>
                    </div>
                    <button type="button" v-on:click="removeReceipt(i)" :disabled="letterLoading" class="float-end btn btn-sm btn-danger"><i class="fas fa-ban"></i> Remove</button>
                </li>
            </ul>
        </div> 
    </div>   
    <div class="form-row mt-2">
        <div class="col-6">
            <h5>Stationery options</h5>
            <div class="form-check form-switch">
                <input type="checkbox" v-model="stock" class="form-check-input" id="useStock">
                <label class="form-check-label" for="useStock">Create with receipt stationery</label>
                <div v-if="stock">
                    <input type="checkbox" v-model="duplicate" class="form-check-input" id="useDuplicate">
                    <label class="form-check-label" for="useDuplicate">Add "re-issue" watermark</label>
                </div>
            </div>        
        </div>
        <div class="col-6">
            <h5>Choose a file output format</h5>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="output" id="outputDocx" value="DOCX" v-model="output">
                <label class="form-check-label" for="outputDocx">.docx file</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="output" id="outputPDF" value="PDF" v-model="output">
                <label class="form-check-label" for="outputPDF">PDF file</label>
            </div>
        </div>
    </div>    
    <div class="form-row mt-3">
        <button type="button" v-on:click="getDocs('ERECEIPT')" :disabled="letters.ERECEIPT == 0 || letterLoading || downloading" class="btn btn-info me-2 text-white"><i class="fas fa-file-download"></i> View {{letters.ERECEIPT}} e-receipt<span v-if="letters.ERECEIPT != 1">s</span></button>        
        <button type="button" v-on:click="getDocs('RECEIPT')" :disabled="letters.RECEIPTS == 0 || letterLoading || downloading" class="btn btn-success me-2"><i class="fas fa-file-download"></i> Get {{letters.RECEIPTS}} receipt<span v-if="letters.RECEIPTS != 1">s</span></button>
        <button type="button" v-on:click="getDocs('MODIFICATION')" :disabled="letters.REVERSALS == 0 || letterLoading || downloading" class="btn btn-primary me-2"><i class="fas fa-file-download"></i> Get {{letters.REVERSALS}} modification<span v-if="letters.REVERSALS != 1">s</span></button>
        <button type="button" v-on:click="getDocs('STOCK')" :disabled="letters.SECURITIES == 0 || letterLoading || downloading" class="btn btn-danger me-2"><i class="fas fa-file-download"></i> Get {{letters.SECURITIES}} stock letter<span v-if="letters.SECURITIES != 1">s</span></button>
        <button type="button" v-on:click="getDocs('IRA')" :disabled="letters.IRA == 0 || letterLoading || downloading" class="btn btn-warning me-2"><i class="fas fa-file-download"></i> Get {{letters.IRA}} IRA letter<span v-if="letters.IRA != 1">s</span></button>        
        <button type="button" v-on:click="getDocs('DAF')" :disabled="letters.DAF == 0 || letterLoading || downloading" class="btn btn-secondary me-2"><i class="fas fa-file-download"></i> Get {{letters.DAF}} DAF letter<span v-if="letters.DAF != 1">s</span></button>                
    </div>   
</div>

</template>
<script>
const lettersDefault = {
    RECEIPTS: 0,    
    SECURITIES: 0,
    IRA: 0,
    DAF: 0,
    ERECEIPT: 0,
    REVERSALS: 0
};

export default {
    data() {
        return {
            loading: false,
            letterLoading: false,
            downloading: false,
            receipt: '',
            stock: false,
            duplicate: false,
            receipts: [],
            letters: lettersDefault,
            output: 'DOCX'
        }
    },
    methods: {
        ereceiptStatus: function(record) {
            var out = 'No e-receipt has been created for this receipt';
            switch (record.REVIEWED) {
                case 'Y':
                    out = 'E-receipt created and reviewed, can be emailed';
                break;
                case 'D':
                    out = 'E-receipt created and reviewed, do not email';
                break;
                case 'N':
                    out = 'E-receipt created, not reviewed';
                break;
                case 'E':
                    out = 'E-receipt sent';
                break;
            }
            return out;
        },
        addReceipt: function() {
            var _this = this;
            //No donor ID
            if (this.receipt.trim() == '') {
                return;
            }            
            
            //Donor ID exists
            if (this.receipts.some(function(r) {                
                return r.RECEIPT_NUMBER == _this.receipt || r.ADV_RECEIPT_NUMBER == _this.receipt;
            })) {
                _this.$root.setAlert(true, 'That receipt has already been included', 'alert-warning');
                return;
            }
            
            this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/receipt/receipt.lookup.php', {
                params: {
                    'receipt_number': this.receipt                                   
                }
            }).then(response => {	                                    
				if (response.data.error) {
					this.$root.setAlert(true, response.data.error, 'alert-danger');
					return;
				} else {
                    if (response.data.length) {
                        this.receipts.push(response.data[0]);
                        this.receipt = '';
                        this.getReceiptLetters();
                    } else {
                        this.$root.setAlert(true, 'The provided receipt number does not exist', 'alert-warning');
					    return;
                    }
				}
    		}).catch(error => {
				this.$root.setAlert(true, error, 'alert-danger');
				return;
    		});
        },
        removeReceipt: function(ind) {
            this.receipts.splice(ind, 1);          
            if (this.receipts.length) {
                this.getReceiptLetters();
            } else {
                this.letters = lettersDefault;
            }
        },
        getDocs: function(type) {            
            if (this.downloading) {                
                return;
            }
            this.downloading = true;
            var data = {};
            var script = '';
            var filename = '';
            var _this = this;              
            var receipts = [];
            var ereceipt = false;
            for (var i = 0; i < this.receipts.length; i++) {
                receipts.push(this.receipts[i].RECEIPT_NUMBER);
            }     
            switch (type) {
                case 'RECEIPT':
                    script = 'receipt.generate.php';
                    data = {
                        'type': 'RECEIPT',                        
                        'receipts': receipts,
                        'stock': this.stock,
                        'duplicate': this.duplicate,
                        'output': this.output,
                        'reversal': 'N'
                    };
                    filename = 'receipts_'+receipts[0];
                    if (receipts.length > 1) {
                        filename = 'receipts_multiple';
                    }
                break;
                case 'MODIFICATION':
                    script = 'receipt.generate.php';
                    data = {
                        'type': 'RECEIPT',                        
                        'receipts': receipts,
                        'stock': this.stock,
                        'duplicate': this.duplicate,
                        'output': this.output,
                        'reversal': 'Y'
                    };
                    filename = 'receipts_'+receipts[0];
                    if (receipts.length > 1) {
                        filename = 'receipts_multiple';
                    }
                break;
                case 'STOCK':
                    script = 'stockLetter.generate.php',
                    data = {
                        'type': 'RECEIPT',
                        'receipts': receipts,
                        'output': this.output
                    };
                    filename = 'stock_letters_'+receipts[0];
                    if (receipts.length > 1) {
                        filename = 'stock_letters_multiple';
                    }
                break;
                case 'IRA':
                    script = 'iraLetter.generate.php',
                    data = {
                        'type': 'RECEIPT',
                        'receipts': receipts,
                        'output': this.output
                    };
                    filename = 'IRA_letters_'+receipts[0];
                    if (receipts.length > 1) {
                        filename = 'IRA_letters_multiple';
                    }
                break;                
                case 'DAF':
                    script = 'dafLetter.generate.php',
                    data = {
                        'type': 'RECEIPT',
                        'receipts': receipts,
                        'output': this.output
                    };
                    filename = 'DAF_letters_'+receipts[0];
                    if (receipts.length > 1) {
                        filename = 'DAF_letters_multiple';
                    }
                break; 
                case 'ERECEIPT': 
                    ereceipt = true;                                                            
                    this.$router.push({ name: 'ereceipt', params: { type: 'receipt', param: receipts.join() } });                                        
                break;
            }          
            if (!ereceipt) {
                this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/'+script, {
                    responseType: 'blob',
                    params: data
                }).then(response => {	                         
                    if (response.data.type == 'text/html') {
                        var d = new Blob([response.data]);
                        var r = new FileReader();
                        r.addEventListener('loadend', (e) => {
                            const err = e.srcElement.result;
                            _this.$root.setAlert(true, err, 'alert-danger');
                        });
                        r.readAsText(d);                                        
                        _this.downloading = false;
                        return;
                    }                                  		                                
                    if (response.data.error) {
                        _this.$root.setAlert(true, response.data.error, 'alert-danger');
                        _this.downloading = false;
                        return;
                    } else {                       
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename+'.'+this.output.toLowerCase());                    
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        _this.downloading = false;			        
                    }
                }).catch(error => {
                    _this.$root.setAlert(true, error, 'alert-danger');
                    _this.downloading = false;
                    return;
                });
            }
        },
        getReceiptLetters: function() {
            this.letterLoading = true;
            var _this = this;
            
            var receipts = [];            
            for (var i = 0; i < this.receipts.length; i++) {
                receipts.push(this.receipts[i].RECEIPT_NUMBER);
            }            
            var params = {
                'receipts': receipts
            };                        
            this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/receipt/letter.lookup.php', {
                params: params
            }).then(response => {	   
                _this.letterLoading = false;                   
				if (response.data.error) {
					this.$root.setAlert(true, response.data.error, 'alert-danger');
					return;
				} else {
                    if (response.data.length) {
                        this.letters = response.data[0][0];                                                
                    } else {
                        this.$root.setAlert(true, 'The provided receipt number does not exist', 'alert-warning');
					    return;
                    }
				}
    		}).catch(error => {
                _this.letterLoading = false;
				this.$root.setAlert(true, error, 'alert-danger');
				return;
    		});
        }
    },
    computed: {
        
    }
}
</script>
<style scoped>
.has-items .form-control, .has-items .btn {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.card {
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.btn-success.dropdown-toggle {
    border-start-color: rgb(25, 105, 44);
}

a.dropdown-item {
    cursor: pointer;
}

a.dropdown-item:active, a.dropdown-item:active i {
    color: #FFF !important;
}

.detail {
    font-size: 0.8rem;
}

.custom-checkbox .custom-control-label::before, .custom-checkbox .custom-control-label::after  {
    margin-top: 4px;
    margin-left: 0px;
}
</style>
